// extracted by mini-css-extract-plugin
export default {"Container":"_Container--UrEjB","Header":"_Header--M04t2"};